import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ion-padding-bottom" }
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", {
  class: "ion-margin-top",
  style: {"border-bottom":"1px solid var(--ion-color-medium)"}
}, null, -1)
const _hoisted_4 = { class: "ion-text-center" }

import {
  CustomElement,
  OrderedCardsList,
  GeneralCardElements,
  TableElement,
  TmpList,
} from "@/types";
import { getCurrentElement, getIcon } from "@/utils";
import {
  IonHeader,
  IonToolbar,
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
} from "@ionic/vue";
import { PropType } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleAdder',
  props: {
  title: {
    type: String,
    required: true,
  },
  emptiness_message: {
    type: Object as PropType<CustomElement>,
    required: true,
  },
  first_row: {
    type: Array<TableElement>,
  },
  show_confirm: {
    type: Boolean,
    default: true,
  },
  sizes: {
    type: [Array, Object] as PropType<
      string[] | TmpList<TmpList<(string | undefined)[]>>
    >,
  },
  data: {
    type: Object as PropType<OrderedCardsList<GeneralCardElements>>,
    required: true,
  },
},
  emits: ["signal_event", "close", "add", "remove", "confirm"],
  setup(__props) {

const props = __props;

const store = useStore();




const elements: {
  [key: string]: CustomElement;
} = {
  close: {
    id: "close",
    type: "icon",
    linkType: "event",
    content: {
      event: "close",
      icon: getIcon("close"),
    },
  },
  title: {
    id: "title",
    type: "title",
    content: props.title,
  },
};
const buttons = [
  {
    id: "add",
    type: "string_icon",
    linkType: "event",
    content: {
      text: getCurrentElement("add"),
      icon: getIcon("add"),
      event: "add",
      whole_link: true,
    },
    ...store.state.button_css,
  },
  {
    id: "confirm",
    type: "string_icon",
    linkType: "event",
    content: {
      text: getCurrentElement("confirm"),
      icon: getIcon("checkmark"),
      event: "add",
      whole_link: true,
    },
    ...store.state.button_css,
  },
];

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_ionic_table = _resolveComponent("ionic-table")!
  const _component_list_card = _resolveComponent("list-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonGrid), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), { class: "ion-text-center ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.title
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCol), { size: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.close,
                          onSignal_event: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonGrid), { class: "ion-no-margin" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), {
                  key: "parameters",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _renderSlot(_ctx.$slots, "parameters")
                    ]),
                    (props.show_confirm)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_ionic_element, {
                            element: buttons[0],
                            onSignal_event: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add')))
                          }, null, 8, ["element"])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_3
                  ]),
                  _: 3
                }),
                _createVNode(_unref(IonCol), {
                  key: "list",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    (props.sizes != undefined && props.first_row !== undefined)
                      ? (_openBlock(), _createBlock(_component_ionic_table, {
                          key: 0,
                          emptiness_message: props.emptiness_message,
                          data: props.data,
                          first_row: props.first_row,
                          sizes: props.sizes,
                          onSignal_event: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('remove')))
                        }, null, 8, ["emptiness_message", "data", "first_row", "sizes"]))
                      : (_openBlock(), _createBlock(_component_list_card, {
                          key: 1,
                          emptiness_message: props.emptiness_message,
                          cards_list: props.data,
                          onSignal_event: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('remove')))
                        }, null, 8, ["emptiness_message", "cards_list"])),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_ionic_element, {
                        element: buttons[1],
                        onSignal_event: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('confirm')))
                      }, null, 8, ["element"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ], 64))
}
}

})